export default function Hero() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative bg-white pt-32 pb-24 px-6 overflow-hidden">
      {/* Background Image with Ombre Fade from Right */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/9c427453adae0e6e5ffb9fcdc5972f14.jpg" 
          alt="Modern House Extension Background" 
          className="w-full h-full object-cover object-top"
        />
        {/* Ombre Gradient Overlay - Fades from white on left to transparent on right */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/70 to-transparent"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        {/* Logo - Text with Growth Icon */}
        <div className="flex items-center gap-6 mb-16">
          <div className="w-24 h-24 flex items-center justify-center bg-white rounded-xl shadow-lg p-2">
            <img 
              src="https://static.readdy.ai/image/0a78d90c9152fb6c1f8f3ab95c0bdb39/388e785e7df1ce97cb4d2ec85e67fec7.png" 
              alt="Growth Chart Icon" 
              className="w-full h-full object-contain"
            />
          </div>
          <h1 className="text-7xl font-bold text-[#1a2947]">Build to Lead</h1>
        </div>

        {/* Hero Content - Left Aligned */}
        <div className="max-w-2xl space-y-8">
          <h2 className="text-7xl font-bold text-[#1a2947] leading-tight drop-shadow-sm">
            <span className="text-[#2B5797]">Lead Generation and Enquiry Automation</span> for House Extension &amp; Loft Conversion Companies
          </h2>
          
          <p className="text-2xl text-[#1a2947] leading-relaxed drop-shadow-sm">
            We generate homeowner enquiries through targeted ads and ensure proper follow-up. For established UK extension and loft conversion companies seeking more enquiries and better job conversion.
          </p>
          
          <p className="text-3xl text-[#1a2947] font-medium drop-shadow-sm">
            More Enquiries. Better Follow-Up. More Jobs.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mt-12">
            <a
              href="#contact"
              className="px-10 py-5 bg-[#1E3A5F] text-white text-xl font-bold rounded-lg hover:bg-[#2B5797] transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer hover:scale-105"
            >
              Book Your Free Strategy Call
              <i className="ri-arrow-right-line ml-3"></i>
            </a>
            <a
              href="#how-it-works"
              className="px-10 py-5 bg-white text-[#334155] text-xl font-bold rounded-lg hover:bg-[#F8FAFC] transition-all duration-300 shadow-xl hover:shadow-2xl whitespace-nowrap cursor-pointer hover:scale-105 border-2 border-gray-200"
            >
              See How It Works
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
